<script type="text/javascript">
	import {onMount, onDestroy} from 'svelte';
	import StringHelper from "../Helpers/StringHelper";

	let textChangeEvent = () => {
		const value = inputField.value;
		const countImos = StringHelper.splitIMOsByCommaOrSpace(value).length;
		const maxImos = parseInt(inputField.attributes.maximos.value);
		element.innerHTML = countImos + " / " + maxImos;

		element.style.color = (countImos >= maxImos)?"red":"";
	};

	let inputField;
	let element;
	onMount(() => {
		inputField = element.parentElement.parentElement.parentElement.querySelector("textarea");
		inputField.addEventListener("input", textChangeEvent);
		inputField.addEventListener("change", textChangeEvent);
		textChangeEvent();
	});
	onDestroy(() => {
		inputField && inputField.removeEventListener("change", textChangeEvent);
	});

</script>

<div class='mdc-text-field-helper-text mdc-text-field-helper-text--persistent' bind:this={element} >0 / 100</div>

<!--
TODO: OK. This should really be done with a modified MDC character counter, but I couldn't figure it out.
The above at least works, but see previous work below. The issue with this is that it resets the counter text when OTHER elements in the forms change.
<script>
/*
 * IMOCounter
 * Copy of @smui/textfield/character-counter, adapted for IMOs.
 */
  import {MDCTextFieldCharacterCounter} from '@material/textfield/character-counter';
  import {onMount, onDestroy} from 'svelte';
  import {current_component} from 'svelte/internal';
  import {forwardEventsBuilder} from '@smui/common/forwardEvents.js';
  import {exclude} from '@smui/common/exclude.js';
  import {useActions} from '@smui/common/useActions.js';

  import StringHelper from "../Helpers/StringHelper";

  const forwardEvents = forwardEventsBuilder(current_component);

  export let use = [];
  let className = '';
  export {className as class};

  let element;
  let characterCounter;
  let textarea = null;

  // This component relies entirely  on being within a HelperText for a Textfield (only <textarea> not <input>)
  // FILTHY HACKS (.js)
  let textChangeEvent = () => {
    const value = textarea.value;
    const countimos = StringHelper.splitIMOsByCommaOrSpace(value);
    const maximos = textarea.attributes.maximos.value;
  	element.innerHTML = countimos.length + " / " + maximos
  };

  onMount(() => {
  	let setCounterValue = (curlen, maxlen) => {
    	console.log("setCounterValue");
    	console.log(characterCounter)
    	console.log(characterCounter.foundation);
    	console.log(characterCounter.getDefaultFoundation());
    };
    characterCounter = new MDCTextFieldCharacterCounter(element);
    characterCounter.setCounterValue = setCounterValue;
    characterCounter.foundation.setCounterValue = setCounterValue;
    characterCounter.foundation.adapter_.setContent = (content) => {
    	console.log('setContent', content);
    }
    characterCounter.getDefaultFoundation().adapter_.setContent =(content) => {
    	console.log('setContent 2', content);
    }
    characterCounter.getDefaultFoundation().setCounterValue = setCounterValue;;



    setCounterValue(0,100);

    textarea = element.parentElement.parentElement.parentElement.querySelector("textarea");
    textarea.addEventListener("input", textChangeEvent);
	textarea.addEventListener("change", textChangeEvent);
	textChangeEvent();
	setTimeout(textChangeEvent, 1);
  });

  onDestroy(() => {
    characterCounter && characterCounter.destroy();
    textarea && textarea.removeEventListener("change", textChangeEvent);
  });
</script>

<div
  bind:this={element}
  use:useActions={use}
  use:forwardEvents
  class="mdc-text-field-character-counter {className}"
  {...exclude($$props, ['use', 'class'])}
><slot></slot></div>
 -->
